var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11721 8.00821C6.56235 8.00821 7.73373 9.17961 7.73373 10.6247C7.73373 12.0699 6.56235 13.2413 5.11721 13.2413C3.67142 13.2413 2.5 12.0699 2.5 10.6247C2.5 9.17961 3.67142 8.00821 5.11721 8.00821ZM5.11721 8.00821L5.11731 3.76172M6.76085 5.41247L5.11659 3.76172L3.47167 5.41247",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8822 13.0778V9.06476M13.1907 11.6339H10.5735M14.4999 6.44859C14.4999 5.00345 13.3284 3.83203 11.8833 3.83203C10.4375 3.83203 9.26611 5.00345 9.26611 6.44859C9.26611 7.89376 10.4375 9.06516 11.8833 9.06516C13.3284 9.06516 14.4999 7.89376 14.4999 6.44859Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.3bcf973eed85e4596d9b8babb24411eb.svg";
export { ForwardRef as ReactComponent };